export const removeEmptyFormField = (dict) => {
  return Object.fromEntries(Object.entries(dict).filter(([k, v]) => v.length > 0))
}

export const capitalizeFirst = str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}

export const getUser = () => {
  return JSON.parse(localStorage.getItem("authUser"))
}

export const havePermission = id => {
  return getUser().user.permissions.includes(id)
}
